import React from 'react';
import { Chip, IconButton, Tooltip as MuiTooltip } from '@mui/material';
import { Close as CloseIcon, Refresh as RefreshIcon } from '@mui/icons-material';

import { Log } from '../../types';
import { LogCopyAllIconButton } from '../LogCopyAllIconButton';
import { LogDownloadIconButton } from '../LogDownloadIconButton';
import s from './FlowRunLogsHeader.module.scss';

type CopyAllProps = {
  logs: Log[];
  tooltip: string;
  visible: boolean;
};

type DownloadLogsProps = {
  logs: Log[];
  tooltip: string;
  fileName: string;
  visible: boolean;
};

type Props = {
  flowId: number;
  fromConnectorLabel: string;
  onClose: () => void;
  onRefresh: () => void;
  copyAll?: CopyAllProps;
  downloadLogs?: DownloadLogsProps;
};

export const FlowRunLogsHeader = ({
  flowId,
  fromConnectorLabel,
  onClose,
  onRefresh,
  copyAll,
  downloadLogs,
}: Props) => {
  const connectorLabelElement = fromConnectorLabel ? (
    <span className={s.fromConnectorText}>from {fromConnectorLabel}</span>
  ) : null;

  return (
    <div className={s.container}>
      <div className={s.left}>
        <MuiTooltip title="Close Logs" arrow placement="top">
          <IconButton onClick={onClose} aria-label="Close Logs" size="large">
            <CloseIcon />
          </IconButton>
        </MuiTooltip>

        <div className={s.fromConnectorContainer}>
          <Chip label={`Flow ID ${flowId}`} className={s.flowIdChip} />
          {connectorLabelElement}
        </div>
      </div>

      <div className={s.right}>
        {copyAll?.visible && <LogCopyAllIconButton logs={copyAll.logs} title={copyAll.tooltip} />}
        {downloadLogs?.visible && (
          <LogDownloadIconButton
            logs={downloadLogs.logs}
            title={downloadLogs.tooltip}
            fileName={downloadLogs.fileName}
          />
        )}
        <MuiTooltip title="Refresh" arrow placement="top">
          <IconButton onClick={onRefresh}>
            <RefreshIcon fontSize="large" />
          </IconButton>
        </MuiTooltip>
      </div>
    </div>
  );
};
